import { type SummaryData } from '../types';

// Per-VIN status that means the asset was added. This field is a plain String
// in the schema (no enum), so its runtime value is a backend contract, not a
// generated type: it is the lowercase Rails model enum value `completed`
// (failures are `failed`), matching the prior per-registration contract. Only
// the upload-level status (AssetBulkUploadStatusEnum) is UPPERCASE.
const ADDED_STATUS = 'completed';

export type Upload = NonNullable<AssetBulkUploadPollQuery['assetBulkUpload']>;

export const zeroedSummary = (): SummaryData => ({
  assetsAddedCount: 0,
  assetsFailedCount: 0,
  depotsAddedCount: 0,
  depotsFailedCount: 0,
  reportUrl: undefined,
  stillProcessing: false,
});

/**
 * Assets has no server-side summary — counts are derived by walking the
 * per-depot registrations. Shared by the wizard's poll and by the completion
 * toast so both report the same numbers.
 */
export const buildSummary = (
  upload: Upload,
  stillProcessing: boolean,
): SummaryData => {
  const summary = zeroedSummary();
  summary.stillProcessing = stillProcessing;
  summary.reportUrl = upload.reportUrl ?? undefined;

  upload.assetRegistrations.forEach((registration) => {
    const added = registration.assetRegistrationStatuses.filter(
      (status) => status.status === ADDED_STATUS,
    ).length;
    const failed = registration.assetRegistrationStatuses.length - added;

    summary.assetsAddedCount += added;
    summary.assetsFailedCount += failed;
    if (added > 0) summary.depotsAddedCount += 1;
    if (failed > 0) summary.depotsFailedCount += 1;
  });

  return summary;
};
